import { render, staticRenderFns } from "./TermView.vue?vue&type=template&id=6e36726f&scoped=true&"
import script from "./TermView.vue?vue&type=script&lang=js&"
export * from "./TermView.vue?vue&type=script&lang=js&"
import style0 from "./TermView.vue?vue&type=style&index=0&id=6e36726f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e36726f",
  null
  
)

export default component.exports